export default __webpack_public_path__ + "static/media/9-bottom.1c1cd648.png";